<template>
    <LayoutPage>
        <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="title"
                :description="description"
            />
        </template>
        <template v-slot:content>
            <div class="box box--space-vertical">
                <div class="mm-section">
                    <div class="mm-section-content">
                        <div class="container-fluid w-100">

                            <div class="box box--space-vertical">
                                <router-link :to="localeRoute('news')"
                                    class="mm-link mm-link--icon-left-space-s">
                                    <i class="icon icon-arrow-left"></i>{{$t('newsIdPage.backToList')}}
                                </router-link>
                            </div>

                            <div v-if="data">
                                <span v-if="tagLabel" class="mm-section__faq-category">
                                    {{tagLabel}}
                                </span>
                                <span class="headline headline--third headline--colored">
                                    {{data.title}}
                                </span>
                            </div>

                            <div v-if="data && data.content"
                                class="mm-section__faq-detial box--space-top text--basic-paragraph">
                                <div v-html="data.content"></div>
                            </div>

                            <div v-else-if="showErrorPage === true">
                                <Error404 />
                                {{$t('newsIdPage.notFound')}}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </template>
    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import webCMS from '@/services/WebCMS';
import LayoutPage from '@/components/layouts/Page';
import { getTranslationIdForTagList } from '@/components/help/utils';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';
import Error404 from '@/components/ui/Error/Error404';


export default {
    components: {
        LayoutPage,
        Error404,
        BannerSmallerWithSearchAndButton
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
        this.loadData();
    },
    data() {
        return {
            data: null,
            showErrorPage: false
        };
    },
    watch: {
        '$route.params.id': function () {
            this.data = null;
            this.loadData();
        }
    },
    methods: {
        loadData() {
            webCMS.getPageBySeoId(this.axios, {seoId: this.pageId})
                .then(res => {
                    this.data = res;
                })
                .catch(e => {
                    console.log('Error: ', e);
                    this.showErrorPage = true;
                })
        }
    },
    computed: {
        pageId() {
            return this.$route.params.id;
        },
        tagLabel() {
            if (this.data && this.data.tags) {
                return this.$t(getTranslationIdForTagList(this.data.tags));
            }

            return null;
        },
        title() {
            return this.data && this.data.title;
        },
        description() {
            return this.data && this.data.description;
        }
    }
}
</script>

